import { Breakpoint, useBreakpoint } from '@/hooks/useBreakpoint';

export function useColumnsVisibilityModel(props: { [key in Breakpoint]: string[] }) {
  const bp = useBreakpoint();
  const allColumns = Array.from(new Set(Object.values<string[]>(props).flat()));
  return allColumns.reduce(
    (columns, column) => ({ ...columns, [column]: (props[bp as Breakpoint] || []).includes(column) }),
    {},
  );
}
